type Props = { 
  src?: string; 
  alt: string;
  fallbackText?: string;
  size?: 'default' | 'large';
};

export default function SupplierLogo({ src, alt, fallbackText, size = 'default' }: Props) {
  const sizeClasses = size === 'large' 
    ? 'max-h-21 sm:max-h-18' 
    : 'max-h-14 sm:max-h-12';

  return (
    <div className="group/logo rounded-xl bg-[#F7F9FC] dark:bg-muted/20 border border-gray-200 dark:border-border h-28 w-full flex items-center justify-center p-4 sm:p-3 transition-all duration-300">
      {src ? (
        <img
          src={src}
          alt={alt}
          className={`${sizeClasses} w-auto object-contain grayscale-[100%] opacity-90 group-hover/logo:grayscale-0 group-hover/logo:opacity-100 transition-all duration-300`}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <div className="text-xl sm:text-2xl font-bold text-muted-foreground/40">
          {fallbackText || alt}
        </div>
      )}
    </div>
  );
}
